<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <h5 class="title-h5 font-family-1 t-white f-w-600">
      {{ $t("new.select_rating") }}
    </h5>
    <div
      class="level_picker_content rating d-flex-column justify-start align-start"
    >
      <div
        class="d-flex-row space-between md-row-to-col"
        :style="{ marginBottom: becomeALegend ? '0px' : '20px' }"
      >
        <LevelAdjusters
          :title="$t('new.current_rating')"
          :description="$t('new.select_current_rating')"
          v-model="ratingRange.min"
          :min="0"
          :max="ratingRange.max - 1"
          :defaul-value="0"
        />
        <LevelAdjusters
          :title="$t('new.desired_rating')"
          :description="$t('new.select_desired_rating')"
          v-model="ratingRange.max"
          :min="ratingRange.min + 1"
          :max="2400"
          :defaul-value="defaulValue"
        />
      </div>
      <!-- BECOME LEGEND -->
      <div
        class="become_legend b-radius-9 d-flex-row space-between"
        style="margin-bottom: 20px"
        v-if="becomeALegend"
        @click.stop="handleBecomeLegend"
        :class="[
          checkoutStore.getBecomeLegend && 'active',
          !isBecomeLegendEnabled && 'disabled',
        ]"
      >
        <img
          src="/images/games/world-of-warcraft-boost/become_legend_bg.webp"
          class="become_a_legend_bg"
          alt="Become Legend Bg"
        />
        <div class="d-flex-row flex-8 justify-start">
          <img
            src="/images/games/world-of-warcraft-boost/become_a_legend_icon.webp"
            alt="become legend"
            height="48"
            width="48"
          />
          <div class="d-flex-column justify-start align-start gap-0">
            <label class="bold-xl font-family-2 t-white">
              {{ $t("new.become_a_legend") }}
            </label>
            <p class="regular-m font-family-2 t-light">
              {{ $t("new.become_legend_desc") }}
            </p>
          </div>
        </div>
        <div class="d-flex-row flex-2 justify-end">
          <Switch :checked="checkoutStore.getBecomeLegend" />
        </div>
      </div>

      <!-- BECOME GLADIATOR -->
      <div
        class="become_legend b-radius-9 d-flex-row space-between"
        style="margin-bottom: 20px"
        v-if="becomeAGladiator"
        @click.stop="handleBecomeLegend"
        :class="[
          checkoutStore.getBecomeGaldiator && 'active',
          !isBecomeLegendEnabled && 'disabled',
        ]"
      >
        <img
          src="/images/games/world-of-warcraft-boost/become_a_gladiator_bg.webp"
          class="become_a_legend_bg gladiator"
          alt="Become Legend Bg"
        />
        <div class="d-flex-row flex-8 justify-start">
          <img
            src="/images/games/world-of-warcraft-boost/become_a_legend_icon.webp"
            alt="become legend"
            height="48"
            width="48"
          />
          <div class="d-flex-column justify-start align-start gap-0">
            <label class="bold-xl font-family-2 t-white">
              {{ $t("new.become_a_gladiator") }}
            </label>
            <p class="regular-m font-family-2 t-light">
              {{ $t("new.become_gladiator_desc") }}
            </p>
          </div>
        </div>
        <div class="d-flex-row flex-2 justify-end">
          <Switch :checked="checkoutStore.getBecomeGaldiator" />
        </div>
      </div>
      <div class="d-flex-column justify-start align-start">
        <DualRangePicker
          :steps="[]"
          :min="0"
          :max="2400"
          v-model="ratingRange"
          :step="50"
        />
        <div
          class="d-flex-row space-between range_slider_ranks"
          style="margin-top: 10px"
        >
          <div
            class="d-flex-column justify-start gap-5 range_slider_rank"
            style="width: max-content"
            v-for="rank in getGameRanks"
            :key="rank"
            :style="{ left: rankPosition(rank.from) }"
          >
            <label class="medium-l font-family-2 t-white sm-hide">{{
              rank.from
            }}</label>
            <img
              :src="rank.image_dark"
              alt="rank image"
              width="30"
              height="30"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LevelAdjusters from "./LevelAdjusters.vue";
import DualRangePicker from "../../commonpickers/DualRangePicker.vue";
import Switch from "../../../custom/Switch.vue";
export default {
  data() {
    return {
      ratingRange: {
        min: 0,
        max: 2400,
      },

      ranks: [
        {
          image_dark:
            "/images/games/world-of-warcraft-boost/ranks/dark/rank_1.webp",
          from: 0,
        },
        {
          image_dark:
            "/images/games/world-of-warcraft-boost/ranks/dark/rank_2.webp",
          from: 975,
        },
        {
          image_dark:
            "/images/games/world-of-warcraft-boost/ranks/dark/rank_3.webp",
          from: 1375,
        },
        {
          image_dark:
            "/images/games/world-of-warcraft-boost/ranks/dark/rank_3.webp",
          from: 1575,
        },
        {
          image_dark:
            "/images/games/world-of-warcraft-boost/ranks/dark/rank_4.webp",
          from: 1775,
        },
        {
          image_dark:
            "/images/games/world-of-warcraft-boost/ranks/dark/rank_4.webp",
          from: 1925,
        },
        {
          image_dark:
            "/images/games/world-of-warcraft-boost/ranks/dark/rank_5.webp",
          from: 2075,
        },
        {
          image_dark:
            "/images/games/world-of-warcraft-boost/ranks/dark/rank_7.webp",
          from: 2375,
        },
      ],
    };
  },
  computed: {
    isBecomeLegendEnabled() {
      if (this.ratingRange.max === 2400 && this.isPilotedSelected) {
        return true;
      }
      return false;
    },
    isPilotedSelected() {
      const pilotedOption = this.getGamePack?.pack_options?.find(
        (option) => option.const_title === "piloted"
      );
      if (!pilotedOption?.id) {
        return false;
      }
      return this.checkoutStore.getPackOptions.includes(pilotedOption.id);
    },
  },
  components: {
    LevelAdjusters,
    DualRangePicker,
    Switch,
  },
  methods: {
    rankPosition(rankForm) {
      const maxRange = 2400;
      let difference = 0;
      let percentage = (rankForm / maxRange) * 100;
      if (percentage > 40) {
        difference = 8;
      }
      if (percentage > 50) {
        difference = 10;
      }

      if (percentage > 70) {
        difference = 31;
      }
      if (percentage > 95) {
        difference = 40;
      }
      return `calc(${percentage}% - ${difference}px)`;
    },
    handleBecomeLegend() {
      if (this.becomeAGladiator) {
        this.checkoutStore.setBecomeGladiator(
          !this.checkoutStore.getBecomeGaldiator
        );
      }
      if (this.becomeALegend) {
        this.checkoutStore.setBecomeLegend(!this.checkoutStore.getBecomeLegend);
      }
    },
  },
  mounted() {
    this.ratingRange.max = this.defaulValue;
  },
  watch: {
    ratingRange: {
      handler() {
        this.checkoutStore.setDetails({
          currentRating: this.ratingRange.min,
          desiredRating: this.ratingRange.max,
        });
      },
      deep: true,
    },
    "ratingRange.max"() {
      let key = "";
      if (this.becomeAGladiator) {
        key = "setBecomeGladiator";
      } else if (this.becomeALegend) {
        key = "setBecomeLegend";
      }
      if (this.ratingRange.max >= 2400 && this.isPilotedSelected && key) {
        if (this.becomeAGladiator) {
          this.checkoutStore.setBecomeGladiator(true);
        } else if (this.becomeALegend) {
          this.checkoutStore.setBecomeLegend(true);
        }
      } else if (key) {
        if (this.becomeAGladiator) {
          this.checkoutStore.setBecomeGladiator(false);
        } else if (this.becomeALegend) {
          this.checkoutStore.setBecomeLegend(false);
        }
      }
    },
    isPilotedSelected() {
      let key = "";
      if (this.becomeAGladiator) {
        key = "setBecomeGladiator";
      } else if (this.becomeALegend) {
        key = "setBecomeLegend";
      }
      if (this.ratingRange.max >= 2400 && this.isPilotedSelected) {
        if (this.becomeAGladiator) {
          this.checkoutStore.setBecomeGladiator(true);
        } else if (this.becomeALegend) {
          this.checkoutStore.setBecomeLegend(true);
        }
      } else {
        if (this.becomeAGladiator) {
          this.checkoutStore.setBecomeGladiator(false);
        } else if (this.becomeALegend) {
          this.checkoutStore.setBecomeLegend(false);
        }
      }
    },
  },

  props: {
    becomeALegend: {
      default: false,
    },
    becomeAGladiator: {
      default: false,
    },
    defaulValue: {
      default: 2400,
    },
  },

  setup() {
    // ...mapGetters([
    //         "getGameRanks",
    //         "checkoutStore.getBecomeLegend",
    //         "checkoutStore.getPackOptions",
    //         "getGamePack",
    //         "checkoutStore.getBecomeGaldiator",
    //     ]),

    const { getGame, getGamePack, getGameRanks } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getGame,
      getGamePack,
      getGameRanks,
      checkoutStore,
    };
  },
};
</script>
